<template>
  <div class="page-content">
    <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="opTypeDesc"
          label="操作类型">
        </el-table-column>
        <el-table-column
          prop="taskName"
          label="任务名称">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间">
        </el-table-column>
      </el-table>
      <Paging
          :total="total"
          pagingStatus=""
          @changePage="currentChange"/>
  </div>
</template>
<script>
// import { logProductStatusList } from '@/api/log'
import { taskLogList } from '@/api/dataAnalyst'
import Paging from '@/components/paging'
export default {
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  components: {
    Paging
  },
  data () {
    return {
      pageParams: {
        pageSize: 10,
        pageNumber: 1
      },
      total: 0,
      tableData: []
    }
  },
  methods: {
    getTaskLogList (searchParams) {
      const params = {
        params: {
          pageSize: this.pageParams.pageSize,
          pageNumber: this.pageParams.pageNumber
        }
      }
      taskLogList(params).then(res => {
        const resData = res.data.data
        this.total = resData.recordCount
        this.tableData = resData.list
      })
    },
    currentChange (val) {
      Object.assign(this.pageParams, {
        pageSize: val.limit,
        pageNumber: val.page
      })
      this.getTaskLogList()
    }
  },
  created () {
    this.getTaskLogList()
  }
}
</script>
<style lang="less" scope>
.page-content{
  .footer{
      padding: 20px 10px ;
    }
  .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
}
</style>
